import { render, staticRenderFns } from "./SetClassLevel.vue?vue&type=template&id=727ed430&scoped=true"
import script from "./SetClassLevel.vue?vue&type=script&lang=ts"
export * from "./SetClassLevel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727ed430",
  null
  
)

export default component.exports